var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"justify-content-md-center"},[_c('b-col',{staticClass:"py-4",attrs:{"sm":"12","md":"6","xl":"4"}},[_c('login-box')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }